<template>
<div class="cap d-flex justify-content-center align-items-center">
    <div class="ipsum">
    <p class="mb-0">Lorium ipsum dolor sit amet</p>
    <h2 class="text-center mb-0">Our Blog</h2>
    </div>
</div>
</template>

<script>


export default {
 
  data () {
    return {
      
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/page4/banner.vue